export default [
  {
    path: "CallCenterSettings",
    name: "CallCenterSettings",
    meta: {
      title: "callCenterConfig"
    },
    component: () =>import("@/views/Home/systemManage/callCenterSettings")
  },
]